export function BounceLoading({ className = "spinner", color = "#fff" }) {
	return (
		<div className={className}>
			<div className="bounce1" style={{ backgroundColor: color }} />
			<div className="bounce2" style={{ backgroundColor: color }} />
			<div className="bounce3" style={{ backgroundColor: color }} />
		</div>
	);
}
